import {
    Arrangers,
    AshesDetail,
    Cars,
    Clergy,
    CoffinBearings,
    Disposal,
    FuneralDressing,
    Grave,
    GraveDigger,
    GraveLedger,
    LimoBookings,
    PlaceOfService,
    PlaceOfViewingItems,
    ReflectionRoom,
    ValuableItems
} from '../FuneralFragments';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';

export default buildTabDataFragment(
    [
        gql`
            fragment DetailsFields on Funeral {
                WebcastConfirmed
                WebcastEmailedLinkToFamily
                WebcastComment
                WebcastRequired

                ClergyRequired
                ExportDate
                ClergyFeeNotRequired

                ReflectionRoomRequired
                DiggerRequired
                LedgerRequired
                HearseRequired
                CarRequired
                LimoRequired

                HearseToPassHouse
                HearseToPassHouseDuration
                HearseToPassHouseDate
                HearseToPassHouseTime

                HearseToPassHouseAfterService
                HearseToPassHouseAfterServiceDate
                HearseToPassHouseAfterServiceDuration
                HearseToPassHouseAfterServiceTime

                HearseDriveAway
                HearseDriveAwayDate
                HearseDriveAwayTime
                HearseDriveAwayDuration

                FollowToDisposal

                HearseComment
                CoffinComment
                RemovePacemaker
                RemovePacemakerPending

                CremationOrder {
                    ID
                    CremationPending
                    CremationNumber
                    DeliveryDate
                    DeliveryTime
                    InsertionDate
                }
            }
        `,
        AshesDetail,
        Cars,
        Clergy,
        CoffinBearings,
        Disposal,
        FuneralDressing,
        Grave,
        GraveDigger,
        GraveLedger,
        LimoBookings,
        PlaceOfService,
        PlaceOfViewingItems,
        ReflectionRoom,
        ValuableItems,
        Arrangers
    ],
    'Funeral'
);
